import { createContext, useContext } from 'react';

export const AuthorizedContext = createContext(false);

export function useAuthorizedContext(): boolean {
    return useContext(AuthorizedContext);
}
